import PropTypes from 'prop-types';
import React from 'react';
import OutputQCForm from 'components/core/forms/OutputQCForm';
import DataExplorerPage from 'components/core/data_explorer/DataExplorerPage';
import TransformationParameterForm from 'components/page/process/variableRetrieval/TransformationParameterForm';


/**
 * The form that renders details for a coordinate system
 */
export default class OutputQC extends TransformationParameterForm {
    static propTypes = {
        process: PropTypes.object,
        processErrors: PropTypes.object,
        exploredDatastreams: PropTypes.object,
        siteFacilities: PropTypes.array
    };

    constructor(props) {
        super(props);
        this._initializePropDependentVariables(props);
    }

    componentWillUpdate(nextProps) {
        this._initializePropDependentVariables(nextProps);
    }

    _initializePropDependentVariables(props) {
        this.coordinateSystemName = props.match.params.coordinateSystem;
        this.dimensionName = props.match.params.dimension;
    }

    renderTitle = () => {
        const dimensionLabel = <span className={this.labelStyle}> {this.coordinateSystemName} ({this.dimensionName})</span>;
        return <span>Setting Quality Metrics of Bin Averaged Data Points: {this.dimensionName ? dimensionLabel : ''} </span>;
    };

    renderDescription = () => {
        return 'Control when the process will flag output data points as bad or indeterminate based on properties of the input values used to compute that point.';
    };

    renderForm = () => {
        return (
            <DataExplorerPage
                process={this.props.process}
                siteFacilities={this.props.siteFacilities}
                exploredDatastreams={this.props.exploredDatastreams}
            >
                <OutputQCForm
                    process={this.props.process}
                    processErrors={this.props.processErrors}
                    exploredDatastreams={this.props.exploredDatastreams}
                    coordinateSystemName={this.coordinateSystemName}
                    dimensionName={this.dimensionName}
                    hasWritePermissions={this.props.hasWritePermissions}
                />
            </DataExplorerPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process/variableRetrieval/outputs/OutputQC.js